<template>
  <div class="image-carousel">
      <div ref="sliderElm" class="swiper-container image-carousel__slider">
        <div class="swiper-wrapper">
          <div v-for="image in galleryImages" class="swiper-slide">
            <img :src="image.url" :alt="image.alt">
          </div>
        </div>
        <div ref="buttonNextElm" class="swiper-button-next">
          <i class="fal fa-chevron-right"></i>
        </div>
        <div ref="buttonPrevElm" class="swiper-button-prev">
          <i class="fal fa-chevron-left"></i>
        </div>
      </div>
      <div ref="sliderThumbnailElm" class="swiper-container image-carousel__slider-thumbnail">
        <div class="swiper-wrapper">
          <div v-for="image in galleryImages" class="swiper-slide">
            <img :src="image.url" :alt="image.alt">
          </div>
        </div>
      </div>
  </div>
</template>

<script lang="ts">
  import { onMounted, ref } from "vue";
  import Swiper, { Pagination, Navigation, Scrollbar, Thumbs, SwiperOptions } from 'swiper';

  interface IImage {
    url: string,
    alter: string
  }

  interface IImageCarouselProps {
    galleryImages: IImage[],
  }

  export default {
    name: 'ImageCarousel',
    props: {
      galleryImages: {
        type: Array,
        required: true,
      }
    },
    setup(props: IImageCarouselProps) {
      let sliderThumbnail: Swiper;
      let slider: Swiper;
      const sliderThumbnailElm = ref<HTMLElement>();
      const sliderElm = ref<HTMLElement>();
      const buttonNextElm = ref<HTMLElement>();
      const buttonPrevElm = ref<HTMLElement>();

      onMounted(() => {
        Swiper.use([Navigation, Pagination, Scrollbar, Thumbs]);

        sliderThumbnail = new Swiper(sliderThumbnailElm.value, {
          spaceBetween: 10,
          slidesPerView: 3,
          freeMode: true,
          autoHeight: true,
          watchSlidesProgress: true,
          breakpoints: {
            900: {
              slidesPerView: 4
            }
          }
        });

        slider = new Swiper(sliderElm.value, {
          slidesPerView: 1,
          navigation: {
            nextEl: buttonNextElm.value,
            prevEl: buttonPrevElm.value,
          },
          thumbs: {
            swiper: sliderThumbnail
          },
        });

        sliderThumbnail.init();
        slider.init();
      })

      return {
        sliderThumbnailElm,
        sliderElm,
        buttonNextElm,
        buttonPrevElm
      }
    }
  };
</script>

